import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { isFeatureEnabledGuard } from '#core/experimentation/experimentation.guard';
import { feedbackFormsFeatureGuard } from '#modules/feedback-forms/guards/feedback-forms-feature.guard';
import { provideGroupFeedbackFormsScope } from '#modules/feedback-forms/models/feedback-forms-scope';
import { AGGREGATED_BOOSTERS_ROUTES } from '#shell/routing/logged-in/groups/aggregated-boosters/aggregated-boosters.routing';
import { AGGREGATED_CAMPAIGNS_ROUTES } from '#shell/routing/logged-in/groups/aggregated-campaigns/aggregated-campaigns.routing';
import { AGGREGATED_REPUTATION_ROUTES } from '#shell/routing/logged-in/groups/aggregated-reputation/aggregated-reputation.routing';
import { AGGREGATED_RESOURCES_ROUTES } from '#shell/routing/logged-in/groups/aggregated-resources/aggregated-resources.routing';
import { AGGREGATED_SEO_ROUTES } from '#shell/routing/logged-in/groups/aggregated-seo/aggregated-seo.routing';
import { AGGREGATED_SETTINGS_ROUTES } from '#shell/routing/logged-in/groups/aggregated-settings/aggregated-settings.routing';
import { AGGREGATED_SOCIAL_NETWORKS_ROUTES } from '#shell/routing/logged-in/groups/aggregated-social-networks/aggregated-social-networks.routing';
import { AGGREGATED_STATISTICS_ROUTES } from '#shell/routing/logged-in/groups/aggregated-statistics/aggregated-statistics.routing';

export const GROUPS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#shell/layouts/logged-in-layout/groups/groups-layout.component').then((m) => m.GroupsLayoutComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'seo',
            },
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('#modules/dashboard/views/calendar/calendar-groups-page.component').then((m) => m.CalendarGroupsPageComponent),
                canActivate: [isFeatureEnabledGuard('release-calendar-aggregated-view', ['/groups'])],
                data: { routePath: RoutePath.DASHBOARD },
            },
            {
                path: 'statistics',
                loadChildren: () => AGGREGATED_STATISTICS_ROUTES,
                data: { routePath: RoutePath.STATISTICS },
            },
            {
                path: 'reputation',
                loadChildren: () => AGGREGATED_REPUTATION_ROUTES,
                data: { routePath: RoutePath.E_REPUTATION },
            },
            {
                path: 'boosters',
                loadChildren: () => AGGREGATED_BOOSTERS_ROUTES,
                data: { routePath: RoutePath.BOOSTERS },
            },
            {
                path: 'seo',
                loadChildren: () => AGGREGATED_SEO_ROUTES,
                data: { routePath: RoutePath.SEO },
            },
            {
                path: 'social-networks',
                loadChildren: () => AGGREGATED_SOCIAL_NETWORKS_ROUTES,
                data: { routePath: RoutePath.SOCIAL_NETWORKS },
            },
            {
                path: 'resources',
                loadChildren: () => AGGREGATED_RESOURCES_ROUTES,
                data: { routePath: RoutePath.RESOURCES },
            },
            {
                path: 'settings',
                loadChildren: () => AGGREGATED_SETTINGS_ROUTES,
                data: { routePath: RoutePath.SETTINGS },
            },
            {
                path: 'campaigns',
                loadChildren: () => AGGREGATED_CAMPAIGNS_ROUTES,
                canActivate: [isFeatureEnabledGuard('release-cdp-campaigns')],
                data: { routePath: RoutePath.CAMPAIGNS },
            },
            {
                // Former URL of the campaigns list, kept alive for bookmarks and shared links.
                // The redirect stays relative: an absolute one drops the query parameters that open the editor on a draft.
                path: 'crm/campaigns',
                redirectTo: 'campaigns/one-off',
            },
            {
                path: 'feedback-forms',
                providers: [provideGroupFeedbackFormsScope()],
                loadChildren: () => import('#modules/feedback-forms/routes/feedback-forms.routes').then((m) => m.FEEDBACK_FORMS_ROUTES),
                canActivate: [feedbackFormsFeatureGuard],
                data: { routePath: RoutePath.FEEDBACK_FORMS },
            },
        ],
    },
];
